import { render } from "./airqualitynpArchive.vue?vue&type=template&id=74f2b41e"
import script from "./airqualitynpArchive.vue?vue&type=script&lang=js"
export * from "./airqualitynpArchive.vue?vue&type=script&lang=js"

import "./airqualitynpArchive.vue?vue&type=style&index=0&id=74f2b41e&lang=scss"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__